import React, { Component } from "react";
import { connect } from "react-redux";
import { addTransition } from "../../redux/actions/actions";
import { withRouter } from "react-router-dom";
import Icon from "../icon/index";
import { Text } from "@sitecore-jss/sitecore-jss-react";
import "./style.scss";
import classNames from "classnames";
import { openModal } from "../../utils";

class CookiesAcceptButton extends Component {
  handleClick(event) {
    const { isPageTransition, pageTransitionTitle, pageTransitionCurtainColor, pageTransitionCurtainDirection, isShowModal, nestedGrid, link, history, toggleIframe, addTransition, callback, isDisabled } = this.props;
    if (isDisabled && isDisabled.value) {
      return false;
    }
    if (isPageTransition && isPageTransition.value) {
      event.preventDefault();
      addTransition(
        "page-curtain",
        link && link.value.href,
        pageTransitionTitle && pageTransitionTitle.value,
        (pageTransitionCurtainDirection && pageTransitionCurtainDirection.fields && pageTransitionCurtainDirection.fields.phrase.value === "right-to-left") || false,
        link && link.value.linktype,
        pageTransitionCurtainColor && pageTransitionCurtainColor.fields && pageTransitionCurtainColor.fields.phrase.value
      );
      return;
    }
    if (isShowModal && isShowModal.value) {
      toggleIframe("", nestedGrid.value);
      openModal(link.value.id);
      return;
    }
    if (link && link.value && link.value.href) {
      if (link.value.linktype === "external" || link.value.target === "_blank") {
        window.open(link.value.href);
      } else {
        history.push(link.value.href);
      }
    }
    if (Object.prototype.toString.call(callback) === "[object Function]") {
      callback(event);
    }
  }
  render() {
    const { width, isDisabled, buttonText, iconName } = this.props,
      iconModal = {
        icon: iconName ? iconName.value : "",
        type: "primary-button"
      },
      widthClass = width ? width : "auto",
      classes = classNames("primary-button cookie-accept-button green", widthClass, { disabled: isDisabled && isDisabled.value });

    return (
      <button className={classes} onClick={this.handleClick.bind(this)}>
        {buttonText != null && <Text tag="span" className="buttonText" field={{ value: buttonText }} />}
        {iconName != null && (
          <div className="icon-container">
            <Icon {...iconModal} />
          </div>
        )}
      </button>
    );
  }
}

const mapDispatchToProps = {
  addTransition: addTransition
};

export default withRouter(connect(null, mapDispatchToProps)(CookiesAcceptButton));
